
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-view-caaf-details',
  templateUrl: './view-caaf-details.component.html',
  styleUrls: ['./view-caaf-details.component.css']
})
export class ViewCaafDetailsComponent implements OnInit {

  constructor() {

  }
  ngOnInit() {
  }
}
